import React, { useEffect, useState } from 'react'
import './style.css'
import { FaLocationCrosshairs } from "react-icons/fa6";
import { Colors } from '../../../config';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import userLocationRetreive from '../../../config/utils/UserLocationRetrieve';
import ReverseGeocoding from '../../../config/utils/ReverseGeoCoding';
import Autocomplete from "react-google-autocomplete";


const BookingFormLocation = (props) => {
  const { onChange } = props

  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null)
  const [address, setAddress] = useState('');
  const [hasSelectedPlace, setHasSelectedPlace] = useState(false);
  const [editData, setEditData] = useState(props?.onEdit())

  const getMyAddress = async (coordinates) => {
    let myAddress = await ReverseGeocoding(coordinates);
    setLoading(false)
    setAddress(myAddress?.formatted_address);
    const { lat: latitude, lng: longitude } = coordinates

    onChange({
      address: myAddress?.formatted_address,
      latitude,
      longitude,
      postalCode: null
    });
  }

  const getMyGeoCode = async (isFetchAddress = false) => {
    let userLocation = await userLocationRetreive();
    if (userLocation?.latitude) {
      setLocation({
        lat: userLocation?.latitude,
        lng: userLocation?.longitude
      })

      if (isFetchAddress == true) {
        setLoading(true)
        let coordinates = { lat: userLocation?.latitude, lng: userLocation?.longitude }
        await getMyAddress(coordinates)
      }
      return
    }
  }


  const currentLocationFetch = async () => {
    let isFetchAddress = true;
    await getMyGeoCode(isFetchAddress);
  }

  // const postCodeValueHandler = (e) => {
  //   setAddress(e)
  //   onChange(e)
  // }

  const handlePlaceSelected = async (place) => {
    if (place && place?.geometry) {
      let formData = {};
      setHasSelectedPlace(true);
      setAddress(place?.formatted_address);
      formData = {
        address: place?.formatted_address,
        latitude: place?.geometry?.location?.lat(),
        longitude: place?.geometry?.location?.lng(),
      }
      const addressComponents = place?.address_components;
      if (addressComponents) {
        const postalCodeComponent = addressComponents.find(component =>
          component.types.includes('postal_code')
        );
        if (postalCodeComponent) {
          formData = {
            ...formData,
            postalCode: postalCodeComponent.long_name
          };
        } else {
          formData = {
            ...formData,
            postalCode: null
          }
        }
      }
      else setHasSelectedPlace(false)
      onChange(formData);
    }
  };


  useEffect(() => {
    if (!editData) {
      getMyGeoCode(true)
    }
  }, [])

  useEffect(() => {
    if (editData) {
      setAddress(editData.address)
      onChange(
        editData.postalCode ? { ...editData } :
          { ...editData, postalCode: null }
      )
    }
  }, [editData])

  useEffect(() => {
    if (hasSelectedPlace) setHasSelectedPlace(false)
  }, [hasSelectedPlace])


  return (
    <React.Fragment>
      {/* <Input 
        type='text' 
        value={address} 
        onChange={(e) => postCodeValueHandler(e.target.value)} 
        placeholder='Enter your postcode' 
        className={`mt-[-2rem] w-full h-12 rounded-md`}
        suffix={loading == false ? 
          <FaLocationCrosshairs 
            size={18} 
            color={Colors.AppYellow} 
            onClick={currentLocationFetch} 
            className='cursor-pointer' /> : 
            <Spin 
              indicator={<LoadingOutlined spin />} 
              size="small" 
            />
        } 
      /> */}
      <div className='flex bg-white rounded-md justify-between items-center px-2 h-[50px]'>
        <div className='w-3/4'>
          <Autocomplete
            apiKey={process.env.REACT_APP_GOOGLE_MAP_API}
            onPlaceSelected={handlePlaceSelected}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            libraries={['places']}
            options={{
              types: [],
              // componentRestrictions: { country: 'pk' },
            }}
            className='w-full h-12 p-3 outline-none rounded-md'
          />
        </div>
        <div className='1/4'>
          {
            !loading ?
              <FaLocationCrosshairs
                size={18}
                color={Colors.AppYellow}
                onClick={currentLocationFetch}
                className='cursor-pointer'
              /> :
              <Spin
                indicator={<LoadingOutlined spin />}
                size="small"
              />
          }
        </div>
      </div>

    </React.Fragment>
  )
}

export default BookingFormLocation